/**
 * @typedef {object} NotificationStatus
 */
export default {

	SUCCESS: 'success'
	, INFO: 'info'
	, ERROR: 'error'
	, WARNING: 'warning'
	, WAITING: 'waiting'
	, PERFORMING: 'performing'
	, UNKNOWN: 'unknown'
}